import * as React from 'react';

const ArrowShareIcon = ({color = 'black', size = 24}) => (
    <svg
        width={size}
        height={size}
        viewBox="1 1 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1 18.509c0-5.341 3.902-9.738 9-10.663V5.511c0-1.872 2.153-2.925 3.631-1.776l8.343 6.489a2.25 2.25 0 0 1 0 3.552l-8.343 6.489C12.153 21.415 10 20.36 10 18.489v-1.97c-2.259.434-4.037 1.597-5.072 3.165-.596.902-1.622 1.09-2.368.88C1.805 20.35 1 19.63 1 18.509M12.403 5.314A.25.25 0 0 0 12 5.51v3.906c0 .138-.113.25-.25.253-3.66.098-6.772 2.342-8.084 5.496A8.7 8.7 0 0 0 3 18.509c0 .135.184.186.258.073l.05-.073a8.6 8.6 0 0 1 1.122-1.341q.428-.416.913-.777c1.716-1.275 3.943-2.009 6.407-2.055.138-.003.25.11.25.247v3.906c0 .208.24.325.403.197l8.343-6.489a.25.25 0 0 0 0-.394z"
            fill={color}
        />
    </svg>
);
export default ArrowShareIcon;
